<template>
  <div class="checkboxes searches clickable" :class="{visible: searchesVisible, collapsable: collapsable}"
       v-show="searches.length">
    <h2 class="shadow" @click="searchesVisible=!searchesVisible">Remembered searches</h2>
    <div class="panel shadow" v-show="searchesVisible || !collapsable">
      <div v-for="exportable in searches" class="remembered-search"
           @click="applyFilter(exportable)">
        <div>
          <span v-for="[label, values] in decodeExportable(exportable)">
            <strong>{{ label }}:</strong> {{ values.join(', ') }};
          </span>
          <span v-show="decodeExportable(exportable).length==0">
            Empty
          </span>
        </div>
        <i class="material-icons clickable" @click.stop="deleteSearch(exportable)">close</i></div>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import FiltersCollection from '@/domain/FiltersCollection'

  export default {
    name: 'FavoritedSearches',
    props: ['collapsable'],
    data () {
      return {
        searchesVisible: true
      }
    },
    computed: {
      ...mapState('destiny/filters', ['searches'])
    },
    methods: {
      decodeExportable (exportable) {
        return Object.entries(FiltersCollection.fromExportable(exportable).displayValues)
      },
      deleteSearch (toDelete) {
        this.$store.commit('destiny/filters/updateSearches', {
          searches: this.searches.filter(needle => needle !== toDelete)
        })
      },
      applyFilter (exportable) {
        this.$store.commit('destiny/filters/applyFilters', {filters: FiltersCollection.fromExportable(exportable).cleanFilters})
      }
    },
    components: {}
  }
</script>

<style lang="scss">
  @import "../styles/settings";
  .searches {
    strong {
      font-weight: 400;
      color: rgba(255, 255, 255, .9);
    }


  }
</style>



// WEBPACK FOOTER //
// FavoritedSearches.vue?5e3746cc